import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, PenLineIcon, FolderKanbanIcon, TrendingUpIcon, RepeatIcon, AwardIcon, MessageSquareIcon } from 'lucide-react';
const FEATURES = [{
  icon: TargetIcon,
  title: 'Goal Tracking',
  body: 'Set a personally meaningful goal and align it with your daily actions.'
}, {
  icon: PenLineIcon,
  title: 'Performance Journaling',
  body: 'Practice a simple 5-minute journalling technique that increases resilience, self-awareness, and stick-to-it-ness.'
}, {
  icon: FolderKanbanIcon,
  title: 'Projects',
  body: 'Prioritize the deep work necessary to reach your goals.'
}, {
  icon: TrendingUpIcon,
  title: '1% Better Actions',
  body: 'Daily reminders of how to tweak your system to work better for you.'
}, {
  icon: RepeatIcon,
  title: 'Habits',
  body: 'Define the simple habits that keep you on track.'
}, {
  icon: AwardIcon,
  title: 'Success Patterns',
  body: 'Practice the habits and rituals that have worked for highly successful people.'
}, {
  icon: MessageSquareIcon,
  title: 'Personalized Feedback',
  body: 'Learn what works for you and what doesn’t, based on your own patterns.'
}];
export function Features() {
  return <section id="features" className="w-full bg-neutral-50 py-24" data-id="element-53" data-mp="32si45gefesoa">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-54" data-mp="32ve1b2ig9dbo">
        <div className="mx-auto max-w-2xl text-center" data-id="element-55" data-mp="3grhquiidoxht">
          <h2 className="text-3xl font-extrabold tracking-tight text-ink sm:text-4xl" data-id="element-56" data-mp="3btzf6kcz8464">
            The Most Important Things in One Place
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-57" data-mp="3qi2pg5y1y20q">
            Eliminate the struggle of juggling different tools. Elevate your process with a single,
            streamlined experience.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-58" data-mp="3btl04jx74ht">
          {FEATURES.map((f, i) => <motion.div key={f.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i % 3 * 0.08
        }} className="rounded-2xl border border-line bg-white p-7" data-id="element-59" data-mp="3uicthd2aaicy" data-mpi={i}>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-ink text-white" data-id="element-60" data-mp="35yzgrmx0u52g">
                <f.icon className="h-5 w-5" data-id="element-61" data-mp="3awr9gj5hpv7p" />
              </span>
              <h3 className="mt-5 text-lg font-bold text-ink" data-id="element-62" data-mp="3fvucjy1wtrd1">{f.title}</h3>
              <p className="mt-2 leading-relaxed text-muted" data-id="element-63" data-mp="3kvgrqd1athoh">{f.body}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}